import styled from "styled-components";
import { COLORS } from "../../../../../assets/constants/styles";

export const MessagesBackground = styled.div`
  background-color: ${COLORS.lightViolet};
  border-radius: 0.75rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MessageWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.$isClient ? "flex-start" : "flex-end")};
  width: 100%;
`;

export const MessageBox = styled.div`
  padding: 1rem;
  border-radius: 0.75rem;
  background-color: ${(props) =>
    props.$isClient ? COLORS.white : COLORS.violet};
  color: ${(props) => (props.$isClient ? COLORS.black : COLORS.white)};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 80%;
  min-width: 20%;
`;

export const MessageAuthor = styled.div`
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const MessageText = styled.div`
  white-space: pre-wrap;
  margin-bottom: 1rem;
`;

export const MessageTimestamp = styled.div`
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
  position: absolute;
  bottom: 0.5rem;
  right: 1rem;
`;
